<div [formGroup]="participationForm" class="tw-w-full sml-control-group tw-mt-5 tw-flex tw-flex-col tw-gap-5">
<div class="sml-control-group">
  <div class="tw-flex tw-gap-1">
    <label for="participationType" class="sml-new-label">Participant Form <sup class="tw-text-alert-800">*</sup></label>
    <i-icon [name]="'info'" class="!tw-w-4 !tw-h-4 tw-text-grey-950" [smlTooltip]="'Select a standard form for your campaign, or use one of your custom forms to gather special details from participants.'" [placement]="'bottom'" mode="always"></i-icon>
  </div>
<div class="tw-relative preview">
<!-- <sml-radio-button [options]="formType" formControlName="formTypes" [showSubheadings]="true" groupIdentifier="participationType" [subheadings]="formSubheadings"  [adjustHeight]="true" [customInputHeight]="true"
></sml-radio-button> -->
<sml-toggle-radio-button [options]="formTypes" formControlName="formType" [iconName]="iconNameVisiblity"
groupIdentifier="participationType" [showSubheadings]="true" [subheadings]="formSubheadings" [adjustHeight]="true" [customInputHeight]="true"
></sml-toggle-radio-button>
<div class="tw-absolute tw-top-[51px] tw-left-[44px]">
  <div class="tw-flex tw-flex-row tw-gap-1 tw-items-center tw-cursor-pointer tw-text-primary-700 tw-font-bold tw-text-xs tw-leading-5" (click)="previewForm()">
      <div>
          Preview Form
      </div>
      <i-icon [name]="'graph'" class="!tw-w-4 !tw-h-4"></i-icon>
  </div>
</div>
</div>
<div class="sml-form-error" *ngIf="control['formType'].invalid && (control['formType'].dirty || control['formType'].touched)">
  <p *ngIf="control['formType'].errors?.['required']" class="tw-text-alert-800">
    <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
  </p>
</div>
</div> 




<div>
    <div class="sml-control-group" *ngIf="showCustomFormDropdown">
        <label for="customFormType" class="sml-label">Your Custom Forms <sup class="tw-text-alert-800">*</sup></label>
        <sml-search-dropdown  [showCreateCustomForm]="true" formControlName="customFormType" [items]="customForms" [position]="'bottom'" (controlTouched)="onControlTouched()" (controlDirty)="onControlDirty()" [isInvalid]="control['customFormType'].invalid && (control['customFormType'].dirty || control['customFormType'].touched)" [customEmptyState]="true"></sml-search-dropdown>
        <div class="sml-form-error" *ngIf="control['customFormType'].invalid && (control['customFormType'].dirty || control['customFormType'].touched)">
          <p *ngIf="control['customFormType'].errors?.['required']" class="tw-text-alert-800">
            <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
          </p>
        </div>
        
        </div>
    </div>

</div>

